import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { Link } from 'react-router-dom'
import logo from '../img/allsafe-logo.png'
import '../styles/custom.css'
import Panel from './Panel'
//import Payments from './Payments';

// {/*<li key="2"><Payments /></li>,*/}

class Header extends Component {
	renderContent() {
		//console.log("user:");
		//console.log(this.props.user);
		//console.log("auth:");
		//console.log(this.props.auth);
		switch (this.props.auth) {
			case null:
				return;
			case false:
				return <li key="0"><a href="/login">Login (lokal)</a></li>;
				//return;
			default:
				return [
					<li key="1" style={{margin: '0 10px'}}>Credits: {this.props.auth.credits}</li>,
					<li key="3"><a href="/login">Logout</a></li>
			];
		}
	}
	componentDidMount() {
		document.title = "Der schlaue Blaue";
		this.props.fetchUser();
	}
	render () {
		return (
			<React.Fragment>
				{this.props.auth && this.props.auth.roles && <Panel user={this.props.auth} history={this.props.history} />}
				<div className="w-100 row">
					<div className="float-left p-3 col-sm-10 display-4">Der schlaue Blaue</div>
	        <div className="w-40 col-sm-2 pt-3 float-right">
	          <Link to="/"><img className="" src={logo} alt="logo"/></Link>
	        </div>
				</div>
				<div className="w-100 row">
					<div className="float-left p-3 col-sm-8 h4">Ladegut-Sicherung und Führerscheinkontrolle<br/>im geschäftlich genutzten Fahrzeug</div>
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps({ auth }) {
	return { auth };
}

export default connect(mapStateToProps, actions)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js